<template>
  <div class="snapshot">
    <h2 class="subtitle-2 date">{{ snapshot.CreatedAt }}</h2>
    <v-layout>
      <v-flex lg8>
        <v-list-item-title class="headline mb-1 title name">
          {{ snapshot.Name }}
          <v-icon class="title-icon" right id="icon-style"
            >fas fa-external--alt</v-icon
          >
        </v-list-item-title>
      </v-flex>

      <v-flex lg4 text-right>
        <v-btn
          id="run-btn-style"
          @click="onRestoreSnapshot"
          v-if="snapshot.Status === 'succeeded'"
          :disabled="
            status !== 'stopped' ||
            status.toLowerCase().includes('during') ||
            templateStatus.toUpperCase() === 'PENDING' ||
            snapshotStatus.toUpperCase() === 'PENDING' ||
            loading ||
            duringRestoring
          "
          title="You can restore snapshot only if the environment is in the stopped state and has no templates in the pending state!"
          class="restore-button"
        >
          <v-icon small left>fas fa-share</v-icon>Restore
        </v-btn>
        <v-icon small left v-else>fas fa-spinner fa-spin</v-icon>

        <v-menu
          nudge-bottom="45"
          nudge-left="100"
          class="dropdown-menu"
          v-if="snapshot.Status === 'succeeded'"
        >
          <template v-slot:activator="{ on }">
            <v-btn class="ml-6 dropdown" fab small v-on="on">
              <v-icon color="#121212">fas fa-ellipsis-v</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item class="dropdown-item" @click="onCreateTemplateFromSnapshot">
              <v-list-item-title>
                <v-icon small left color="#6DB42C">fas fa-plus-circle</v-icon>Create Template from snapshot
              </v-list-item-title>
            </v-list-item>
            <v-divider />-->
            <v-list-item
              :disabled="loading || status.toUpperCase() === 'DURING_RESTORE'"
              class="dropdown-item"
              @click="showDeleteDialog = !showDeleteDialog"
            >
              <v-list-item-title>
                <v-icon small left color="#6DB42C">far fa-trash-alt</v-icon
                >Delete snapshot
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <span class="author">{{ snapshot.CreatedBy }}</span>

    <p class="description">{{ snapshot.Description }}</p>
    <DeleteDialog
      :showDeleteDialog.sync="showDeleteDialog"
      :isSnapshot="true"
      @confirmDeleteDialog="confirmDeleteDialog"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DeleteDialog from "../DeleteDialog";

export default {
  data() {
    return {
      showDeleteDialog: false,
      loading: false,
    };
  },
  props: [
    "snapshot",
    "status",
    "templateStatus",
    "snapshotStatus",
    "environmentId",
    "isConnected",
  ],
  components: { DeleteDialog },
  computed: mapGetters(["duringRestoring"]),
  methods: {
    ...mapActions([
      "deleteSnapshot",
      "restoreSnapshot",
      "restoreConnectedSnapshot",
      "createTemplateFromSnapshot",
      "getSnapshots",
      "getConnectedSnapshots",
    ]),
    cancelDeleteDialog() {
      this.showDeleteDialog = false;
    },
    async confirmDeleteDialog() {
      await this.deleteSnapshot(this.snapshot.SnapshotGroupId);
      !this.isConnected
        ? await this.getSnapshots(this.environmentId)
        : await this.getConnectedSnapshots(this.environmentId);
      this.showDeleteDialog = false;
    },
    async onRestoreSnapshot() {
      this.loading = true;
      if (!this.isConnected) {
        await this.restoreSnapshot(this.snapshot.SnapshotGroupId);
      } else {
        const params = {
          connectedEnvId: this.environmentId,
          id: this.snapshot.SnapshotGroupId,
        };
        console.log(params)
        await this.restoreConnectedSnapshot(params);
      }
      this.loading = false;
    },
    async onCreateTemplateFromSnapshot() {
      await this.createTemplateFromSnapshot(this.snapshot.id);
    },
  },
};
</script>

<style scoped>
.snapshot .date,
.name,
.author,
.description,
.dropdown-menu {
  font-family: "Montserrat", "Material Icons";
}

.snapshot {
  border-bottom: 1px solid #eeeeee;
}

.snapshot:not(:first-child) {
  margin-top: 20px;
}

.snapshot .date {
  color: #d0398b;
  font-weight: bold;
}

.snapshot .name {
  font-weight: bold;
}

.snapshot .author {
  color: #888888;
  font-weight: 500;
  font-size: 0.9em;
}

.snapshot .description {
  margin-top: 15px;
  color: #121212;
  font-size: 0.9em;
}

.snapshot .dropdown {
  background: #eeeeee !important;
  box-shadow: none;
}

.dropdown-item:hover {
  background: #eeeeee;
  cursor: pointer;
}

.v-menu {
  z-index: 10000;
}

.restore-button {
  pointer-events: auto;
}
</style>